import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";
import Paper from "@mui/material/Paper";

const DivisionTable = (props) => {
  const navigate = useNavigate();

  const rows = props.rows;
  const rowsLength = rows.length;

  const handleClickView = (event) => {
    navigate(`/divisao/${event.currentTarget.id}`);
  };

  if (rowsLength === 0) {
    return (
      <Typography sx={{ color: "error.main" }}>
        Erro ao carregar a tabela
      </Typography>
    );
  } else {
    const cells = rows.map((row) => (
      <StyledTableRow
        key={row.id}
        id={row.id}
        onClick={handleClickView}
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        <StyledTableCell>{row.uorg}</StyledTableCell>
        <StyledTableCell>{row.nome}</StyledTableCell>
        <StyledTableCell>{row.descricao}</StyledTableCell>
      </StyledTableRow>
    ));
    return (
      <Box sx={{ mb: 2 }}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="data table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>UORG</StyledTableCell>
                <StyledTableCell>Nome</StyledTableCell>
                <StyledTableCell>Descrição</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{cells}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
};

DivisionTable.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default DivisionTable;
